import { ChevronLeftIcon, DownloadIcon } from "@radix-ui/react-icons";
import { Box, Button, Flex } from "@radix-ui/themes";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PdfType } from "../redux/slices/report/report";
import { RootState } from "../redux/store";
import { routes } from "../routes";
import { generatePDF_HTML } from "../utils/reportUtils";
import { StudentCard } from "./school/StudentCard";
import { StudentCertificate } from "./school/StudentCertificate";
import { StudentCredential } from "./school/StudentCredential";
import { StudentDeclaration } from "./school/StudentDeclaration";
import { StudentDiploma } from "./school/StudentDiploma";
import StudentProcessV2 from "./school/StudentProcessV2";
import { SubscriptionReportV2 } from "./school/SubscriptionReportV2";
import { ResetPassword } from "./users/ResetPassword";
import { useAppDispatch } from "../hooks/hooks";
import { resetPreviousPath } from "../redux/slices/previousPath";
import { isEmpty } from "lodash";
import { resetSubscriptionData } from "../redux/slices/school/subscription";
import { Receipt } from "./finance/Receipt";
import { Invoice } from "./finance/Invoice";
import { resetUserData } from "../redux/slices/users/user";
import { resetStudentData, resetStudentListData } from "../redux/slices/school/student";
import { resetStudentDebtData } from "../redux/slices/finance/studentDebt";
import { StudentSituationPdf } from "./school/StudentSituation";
import { StudentsList } from "./StudentsList";
import StudentsGrades from "./StudentsGrades";
import { References } from "./finance/References";

export const PdfPreview: React.FC = () => {

  const pdfPreviewTypeDataLS = localStorage.getItem("pdfPreviewTypeData");
  const preloadedPdfPreviewTypeDataLS: PdfType = pdfPreviewTypeDataLS as PdfType;

  const pdfPreviewTypeData_REFS = localStorage.getItem("pdfPreviewTypeData_REFS");
  const preloadedpdfPreviewTypeData_REFS: PdfType = pdfPreviewTypeData_REFS as PdfType;

  const pdfPreviewTypeDataLS_SP = localStorage.getItem("pdfPreviewTypeData_SP");
  const preloadedPdfPreviewTypeDataLS_SP: PdfType = pdfPreviewTypeDataLS_SP as PdfType;

  const reportTypeFromState = useSelector((state: RootState) => state.report.type);
  let reportType = preloadedPdfPreviewTypeDataLS || preloadedPdfPreviewTypeDataLS_SP ||preloadedpdfPreviewTypeData_REFS || reportTypeFromState;
 // reportType= 'INVOICE' as PdfType;
  const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const previousPath = useSelector((state: RootState) => state.previousPath);

  const renderPdf = () => {
    const knownPdfComponents: { [key: string]: JSX.Element } = {
      'RESET_PASSWORD': (<ResetPassword />),
      'STUDENT_CARD': (<StudentCard />),
      'STUDENT_PROCESS': (<StudentProcessV2 />),
      'SUBSCRIPTION': (<SubscriptionReportV2 />),
      'CERTIFICATE': (<StudentCertificate />),
      'DECLARATION': (<StudentDeclaration />),
      'CREDENTIAL': (<StudentCredential />),
      'DIPLOMA': (<StudentDiploma />),
      'INVOICE': (<Invoice />),
      'RECEIPT': (<Receipt />),
      'STUDENT_SITUATION': (<StudentSituationPdf />),
      'STUDENTS_LIST': (<StudentsList />),
      'STUDENTS_GRADES': (<StudentsGrades />),
      'REFERENCES': (<References />),
    };
    return knownPdfComponents[reportType];
  }
  const handlePrint = async (e: any) => {
    e.preventDefault();
    const fileName = `${reportType}-${(new Date()).toDateString()}.pdf`;
    await printFile(fileName);
  }
  const handleBack = async (e: any) => {
    e.preventDefault();
    if (reportType === 'STUDENT_CARD' || reportType === 'STUDENT_PROCESS') {
        const path = previousPath?.previousPath;
        if(isEmpty(path)){
          navigate(routes.printEnrollmentDocs);
        }else{
          dispatch(resetPreviousPath())
          navigate(path!)
        }
      return;
    }
    if (reportType === 'CERTIFICATE'
      || reportType === 'DECLARATION'
      || reportType === 'CREDENTIAL'
      || reportType === 'DIPLOMA'
    ) {
      navigate(routes.emitStudentDocuments);
      return;
    }
    if (reportType === 'SUBSCRIPTION') {
      dispatch(resetSubscriptionData());
      navigate(routes.subscriptions);
      return;
    }
    if (reportType === 'INVOICE'
      || reportType === 'RECEIPT') {
      const path = previousPath?.previousPath;
      if (isEmpty(path)) {
        navigate(routes.studentDebts);
      } else {
        dispatch(resetPreviousPath())
        dispatch(resetUserData())
        dispatch(resetStudentData())
        dispatch(resetStudentDebtData())
        navigate(path!)
      }

      return;
    }
      if(reportType === 'STUDENT_SITUATION'){ 
        dispatch(resetUserData())
        dispatch(resetStudentData())
        navigate(routes.createStudentSituation)
        return;
      }
      if(reportType === 'STUDENTS_LIST'){ 
        dispatch(resetStudentListData())
        dispatch(resetPreviousPath());
        const path = previousPath?.previousPath;
        if(isEmpty(path)){
          navigate(routes.students);
        }else{
          dispatch(resetPreviousPath())
          navigate(path!)
        }
        return;
      }
    navigate(routes.users)
  }
  const printFile = async (fileName: string) => {
    try {
      const pdf = await generatePDF_HTML();
      pdf.save(fileName);
    } catch (e) {
      console.error(e);
    }
  }
  return <Box>
    <Flex gap='4' align='end'>
      <Button color="red" onClick={handleBack} >
        <ChevronLeftIcon /> Voltar
      </Button>
      <Button onClick={handlePrint} >
        <DownloadIcon /> Imprimir
      </Button>
    </Flex>

    <Flex>
      {renderPdf()}
    </Flex>
  </Box>
}